import { Dispatch, SetStateAction } from 'react';
import { ace_index, loan_application } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function Purpose({ query, setQuery, editable = false }: Props) {
  const state = getPurpose(query);
  const filter = options.find((option) => option.value === state) ?? options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setPurpose(option.value))}
      stringify={(option) => option.label}
      value={filter}
      label="Purpose"
      description="Filter the purpose of the application"
      disabled={!editable}
    />
  );
}

const options: { label: string; value: Value }[] = [
  { label: 'All', value: undefined },
  ...Object.values(loan_application.Purpose).map((purpose) => ({
    label: purpose,
    value: purpose,
  })),
];

function setPurpose(purpose: Value): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    LoanApplicationPurposes: purpose === undefined ? undefined : [purpose],
  });
}

function getPurpose(query: ace_index.FindInput) {
  const purpose = query.LoanApplicationPurposes;

  if (!purpose || purpose.length < 1) {
    return undefined;
  }

  return purpose[0];
}

type Value = loan_application.Purpose | undefined;
